import React from "react";
import {isEmpty} from "../../../_helpers/commonFunctions";
import {useTranslation} from "../../../hooks/useTranslation";

const TextArea = ({label, rows, value, onChange, onBlur, className, placeholder, name, limit, defaultValue, disabled, required}) => {
    const {t} = useTranslation();

    return (
        <div className={className ? className : 'mb-3'}>
            {label && label !== '' && (
                <label>{label}{required && <span className="text-danger"> *</span>}</label>
            )}
            <textarea
                onChange={(e) => onChange && onChange(e)}
                onBlur={(e) => onBlur && onBlur(e)}
                className={"form-control"}
                placeholder={isEmpty(placeholder) ? t('insertPlaceholders.add') + label : placeholder}
                name={name}
                rows={rows}
                maxLength={limit}
                value={value}
                defaultValue={defaultValue}
                disabled={disabled}
            />
        </div>
    )
}

export default TextArea;
